<div class="card-body">
    <div id="apex-image-with-pie-chart"></div>
</div>